import { createAsyncThunk } from '@reduxjs/toolkit';

import {
  createConsumerUnitService,
  deleteConsumerUnitService,
  getConsumerUnitInvoiceListService,
  getConsumerUnitService,
  listConsumerUnitService,
  updateConsumerUnitService,
  uploadConsumerUnitImageService,
} from 'services/consumer_unit.service';

import {
  CreateConsumerUnitProps,
  DeleteConsumerUnitProps,
  GetConsumerUnitInvoiceListProps,
  GetConsumerUnitProps,
  UpdateConsumerUnitProps,
  UploadConsumerUnitImageProps,
} from 'entities/ConsumerUnit';

export const getConsumerUnit = createAsyncThunk(
  'consumerUnit/getConsumerUnit',
  async (data: GetConsumerUnitProps, thunkApi) => {
    try {
      const response = await getConsumerUnitService(data);

      return response.data;
    } catch (error: unknown) {
      return thunkApi.rejectWithValue(error);
    }
  }
);

export const getConsumerUnitList = createAsyncThunk(
  'consumerUnit/list',
  async (_, thunkApi) => {
    try {
      const response = await listConsumerUnitService();

      return response.data;
    } catch (error: unknown) {
      return thunkApi.rejectWithValue(error);
    }
  }
);

export const getConsumerUnitInvoices = createAsyncThunk(
  'consumerUnit/getConsumerUnitInvoiceList',
  async (data: GetConsumerUnitInvoiceListProps, thunkApi) => {
    try {
      const response = await getConsumerUnitInvoiceListService(data);

      return response.data;
    } catch (error: unknown) {
      return thunkApi.rejectWithValue(error);
    }
  }
);

export const createConsumerUnit = createAsyncThunk(
  'consumerUnit/createConsumerUnit',
  async (data: CreateConsumerUnitProps, thunkApi) => {
    try {
      const response = await createConsumerUnitService(data);

      return response.data;
    } catch (error: unknown) {
      return thunkApi.rejectWithValue(error);
    }
  }
);

export const updateConsumerUnit = createAsyncThunk(
  'consumerUnit/updateConsumerUnit',
  async (data: UpdateConsumerUnitProps, thunkApi) => {
    try {
      const response = await updateConsumerUnitService(data);

      return response.data;
    } catch (error: unknown) {
      return thunkApi.rejectWithValue(error);
    }
  }
);

export const uploadConsumerUnitImage = createAsyncThunk(
  'consumerUnit/uploadConsumerUnitImage',
  async (data: UploadConsumerUnitImageProps, thunkApi) => {
    try {
      const response = await uploadConsumerUnitImageService(data);

      return response.data;
    } catch (error: unknown) {
      return thunkApi.rejectWithValue(error);
    }
  }
);

export const deleteConsumerUnit = createAsyncThunk(
  'consumerUnit/deleteConsumerUnit',
  async (data: DeleteConsumerUnitProps, thunkApi) => {
    try {
      const response = await deleteConsumerUnitService(data);

      return response.data;
    } catch (error: unknown) {
      return thunkApi.rejectWithValue(error);
    }
  }
);
